module.exports = __webpack_public_path__ + "static/media/Master.0e4ed658.svg";